<!-- vill flytta till sidhuvudet -->
<form [formGroup]="agreementForm">
    <app-form-section>
        <app-form-row>
            <app-form-group>
                <app-agreement-summary
                    #summaryComp
                    [agreementCreated]="agreementCreated"
                    [agreementForm]="agreementForm"
                    (isCreatingPdf)="createPdf($event)"
                ></app-agreement-summary>
            </app-form-group>
            <!-- <app-form-group *ngIf="!createPdfMode">
                <app-pdf-viewer [id]="'file1'" [file]="fileForm"></app-pdf-viewer>
            </app-form-group> -->
        </app-form-row>
    </app-form-section>
</form>

<!-- Edit mode enabled template-->
<ng-template #editModeFooterTemplate>
    <button class="secondary" (click)="cancel()">
        {{ 'BUTTONS.CANCEL' | translate }}
    </button>
    <button class="primary green" [class.loading]="submitting" [disabled]="submitting" (click)="save()">
        {{ 'BUTTONS.SAVE' | translate }}
    </button>
</ng-template>
